import { API_URL } from "../constants";

export const GET_LIST_BLOGS =(page:string, size:string)=> `${API_URL}blog/public/?page=${page}&size=${size}`
export const GET_LIST_BLOGS_BY_LABELS = (page:string, size:string, label:string)=> `${API_URL}blog/public/?page=${page}&size=${size}&label=${label}`

export const GET_CONTENT_BLOG = (idBlog:string)=> `${API_URL}BlogContent/public/ByIdBlogActive/${idBlog}/`;